import { Box, Flex, Heading } from "@chakra-ui/react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

export default function ThreeMonthBarSection({
  data = [],
  onMonthClick,
  selectedMonth,
  height = 420,
  headerActions,
}) {
  return (
    <Flex
      h="100%"
      direction="column"
      bg="white"
      p={4}
      borderRadius="lg"
      border="1px solid"
      borderColor="gray.100"
      boxShadow="sm"
      overflow="hidden"
    >
      <Flex flexShrink={0} justify="space-between" align="center" gap={4} mb={2} flexWrap="wrap">
        <Heading size="sm" color="gray.800">
          최근 3개월 지급 그래프
        </Heading>
        {headerActions}
      </Flex>

      <Box flex="1" minH="260px">
        <ResponsiveContainer width="100%" height={height}>
          <BarChart
            data={data}
            margin={{ top: 8, right: 8, left: 0, bottom: 0 }}
          >
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis dataKey="label" />
            <YAxis width={72} />
            <Tooltip />

            <Bar dataKey="total" barSize={82} radius={[8, 8, 0, 0]} isAnimationActive={false} cursor="pointer" onClick={(entry) => {
              if (entry?.payload?.key) onMonthClick?.(entry.payload.key);
            }}>
              {data.map((entry, index) => {
                const isSelected = entry.key === selectedMonth;

                return (
                  <Cell
                    key={entry.key || index}
                    fill={isSelected ? "#3182CE" : "#CBD5E0"}
                  />
                );
              })}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </Box>
    </Flex>
  );
}
